module.exports = __webpack_public_path__ + "img/sr-vinho.21d864bc.jpg";